import React from 'react';
import { Activity, Loader2, Server } from 'lucide-react';
import { QUEUE_TYPES } from './useWhatsappConfig';
import { QUEUE_ICONS } from './WhatsappConfigComponents';

export default function WhatsappQueuePanel({
    currentQueueType,
    isLoadingQueue,
    selectedQueueType,
    setSelectedQueueType,
    isUpdatingQueue,
    onUpdateQueue,
}) {
    const currentInfo = QUEUE_TYPES.find(q => q.value === currentQueueType);
    const colorMap = { blue: 'text-blue-300 bg-blue-500/20', green: 'text-green-300 bg-green-500/20', red: 'text-red-300 bg-red-500/20' };
    const colorClass = currentInfo ? colorMap[currentInfo.color] : 'text-gray-300 bg-gray-500/20';

    return (
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 shadow-2xl mb-6">
            <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-cyan-500/20 rounded-xl flex items-center justify-center">
                    <Activity className="w-5 h-5 text-cyan-400" />
                </div>
                <h3 className="text-xl font-semibold text-white">Queue Management</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Current Queue */}
                <div className="bg-white/5 border border-white/10 rounded-xl p-4">
                    <div className="flex items-center space-x-3 mb-3">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${colorClass}`}>
                            {isLoadingQueue ? <Loader2 className="w-4 h-4 animate-spin" /> : (QUEUE_ICONS[currentQueueType] || <Server className="w-4 h-4" />)}
                        </div>
                        <div>
                            <p className="text-white/60 text-xs uppercase tracking-wider">Current Queue</p>
                            <p className={`font-medium text-sm ${currentInfo ? `text-${currentInfo.color}-300` : 'text-gray-300'}`}>
                                {isLoadingQueue ? 'Loading...' : currentInfo?.label || 'Unknown'}
                            </p>
                        </div>
                    </div>
                    {currentQueueType !== null && (
                        <span className={`inline-flex items-center space-x-2 px-3 py-1 rounded-full text-xs ${colorClass}`}>
                            <span className={`w-2 h-2 rounded-full bg-${currentInfo?.color}-400 animate-pulse`} />
                            <span>Active</span>
                        </span>
                    )}
                </div>

                {/* Switch Queue */}
                <div className="bg-white/5 border border-white/10 rounded-xl p-4">
                    <p className="text-white/60 text-xs uppercase tracking-wider mb-3">Switch Queue Type</p>
                    <select
                        value={selectedQueueType}
                        onChange={e => setSelectedQueueType(e.target.value)}
                        disabled={isUpdatingQueue}
                        className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/50 mb-4"
                    >
                        {QUEUE_TYPES.map(t => (
                            <option key={t.value} value={t.value} className="bg-slate-800 text-white">{t.label}</option>
                        ))}
                    </select>
                    <button
                        onClick={onUpdateQueue}
                        disabled={isUpdatingQueue || selectedQueueType === currentQueueType}
                        className="w-full py-2 rounded-lg font-medium text-sm bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                    >
                        {isUpdatingQueue
                            ? <span className="flex items-center justify-center space-x-2"><Loader2 className="w-4 h-4 animate-spin" /><span>Updating...</span></span>
                            : 'Switch Queue Type'
                        }
                    </button>
                </div>
            </div>
        </div>
    );
}